import React from 'react'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import * as Displays from 'support/displays'
import CreateSpecialDaySmartview from 'widgets/smartviews/shifts/CreateSpecialDaySmartview'
import * as Icons from 'ui/icons'
import * as UI from 'ui'
import { useValue } from '@morningtrain/react-resources'

export default function SpecialDay () {
  const id = useValue('id')

  return (
    <MountSmartviewOnClick smartview={<CreateSpecialDaySmartview id={id} />} replace={false}>
      <div className='special-day'>
        <UI.SpaceBetween>
          <UI.WithSubtitle subtitle={(
            <UI.Text truncate className='w-48'>
              <Displays.Text name='department_names' />
            </UI.Text>
          )}
          >
            <Displays.Text name='name' />
          </UI.WithSubtitle>
          <UI.SquareButton color='btn-lightgray'>
            <Icons.Pencil className='w-4 h-4' />
          </UI.SquareButton>
        </UI.SpaceBetween>
      </div>
    </MountSmartviewOnClick>
  )
}
